import axios from 'axios';
import albumReviewsData from '../../data/album_reviews.json';

const API_URL = process.env.REACT_APP_API_URL
const STATIC_WEBSITE = process.env.REACT_APP_STATIC_WEBSITE === 'True'

const AlbumReviewService = {
    getAllReviews: async () => {
        try {
            if (STATIC_WEBSITE) {
                return albumReviewsData;
            } else {
                const response = await axios.get(`${API_URL}/albumreviews/`);
                return response.data;
            }
        } catch (error) {
            console.error('Error fetching tracks:', error);
            throw error;
        }
    },
    
    getCount: async () => {
        try {
            if (STATIC_WEBSITE) {
                return albumReviewsData.length;
            } else {
                const response = await axios.get(`${API_URL}/albumreviews/count/`);
                return response.data.count;
            }
        } catch (error) {
            console.error('Error fetching review count:', error);
            throw error;
        }
    }
};

export default AlbumReviewService;